import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { NavbarText, Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

const ROLES_INCLUDES = ['admin', 'owner']
const DEFAULT_STATE = {
  show: false,
  text: '',
  additionalText: '',
  button: 'dashboard_add-payment-method',
  url: '/dashboard/management/company/<id>/payment/edit'
}

const getDiffDate = (date1) => {
  const date = new Date(date1)

  const result = (date - Date.now()) / 86400000

  return result > 0 ? Math.floor(result) : 0
}

function getBillingNotDataComplete() {
  return {
    button: 'buttons_addBillingData',
    url: '/dashboard/management/company/<id>/edit'
  }
}

const getHeaderNotice = (body) => {
  const { isInTrial, text, endAt, role, companySubtype, companyPaid } = body

  if (!ROLES_INCLUDES.includes(role)) return { ...DEFAULT_STATE }

  if (isInTrial && text) {
    let d = {}
    if (text === 'billing_data_not_complete') {
      d = getBillingNotDataComplete()
    }

    return { ...DEFAULT_STATE, show: true, text, ...d }
  }

  if (!isInTrial && !companyPaid && !text) return {
    ...DEFAULT_STATE, show: true,
    text: companySubtype === 'OP-PC' ? 'notice_trial_expired_op-pc' : 'notice_trial_expired'
  }

  if (!isInTrial && text) {
    const additionalText = endAt ? getDiffDate(endAt) : ''

    const value = { ...DEFAULT_STATE, show: true, text, additionalText }
    if (text === 'billing_data_not_complete') {
      const d = getBillingNotDataComplete()
      value.button = d.button
      value.url = d.url
    }

    return value
  }

  return { ...DEFAULT_STATE }
}

/**
 * HeaderNotice for company notice
 * @param {object} props
 * @param {function} props.onChange It receives a boolean, and it is only called if notice changes
 */
const HeaderNotice = (props) => {
  const { onChange } = props

  const history = useHistory()

  const operator = useSelector(store => store.user)
  const company = useSelector(store => store.companies)
  const { trialAt, notice, subtype, paid } = company
  const { text = '', endAt = '' } = notice || {}

  const [state, setState] = useState({ ...DEFAULT_STATE })

  useEffect(() => {
    const isInTrial = Date.now() - new Date(trialAt) < 0

    const value = getHeaderNotice({
      isInTrial, text, endAt, role: operator.role,
      companySubtype: subtype, companyPaid: paid
    })

    setState({ ...value })

    onChange(value.show)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trialAt, text, endAt, operator.role, subtype, paid])

  if (!state.show) return null

  return (
    <NavbarText className='ml-auto'>
      <label className='text-white font-weight-bold'>
        {I18n.t(state.text).replace('<%VAR%>', state.additionalText)}
      </label>
      <Button color='primary rounded ml-3 font-weight-bold'
        onClick={() => history.push(state.url.replace('<id>', company._id))}
      >
        {I18n.t(state.button)}
      </Button>
    </NavbarText>
  )
}

export default HeaderNotice